<template>
    <div style="padding-bottom: 70px;">
        <div class="shop-main">
            <div class="page-header">
                <h2>门店详情</h2>
                <div class="icon-xian"></div>
            </div>
            <div class="content">
                <div>
                    <div class="text">
                        <h3>{{ shopInfo.name }}</h3>
                        <div><i class="iconfont icon-iconfonti"></i>联系电话：{{ shopInfo.tel }}</div>
                        <div><i class="iconfont icon-iconfonti"></i>联系地址：{{ shopInfo.addressDetail }}</div>
                    </div>
                </div>
                <div :style="'height: 400px; background-color:#90ca6f; background-size:cover; background-image: url('+shopInfo.mapImageUrl+')'">
                    <!--<div style="width:100%; height:400px;" id="dituContent"></div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    /*let markerArr = [{
        title: '我的标记',
        content: '我的备注',
        point: '104.072366|30.656463',
        isOpen: 0,
        icon: { w: 21, h: 21, l: 0, t: 0, x: 6, lb: 5 }
    }];*/
    let that;
    import areaData from '@/js/area.js'
    export default {
        name: 'shop',
        data() {
            return {
                shopInfo: {},
                shopId: 0,
                markerArr: [{
                    title: '我的标记',
                    content: '我的备注',
                    point: '104.072366|30.656463',
                    isOpen: 0,
                    icon: { w: 21, h: 21, l: 0, t: 0, x: 6, lb: 5 }
                }]
            }
        },
        async mounted(){
            that = this;
            await areaData.getAreasData();
            this.getShowInfo();
        },
        methods: {
            //获取店铺信息
            getShowInfo() {
                this.shopId = this.$route.params.id
                this.axios.get(window.consts.apis.shopInfo + '?Id=' + this.shopId).then(res => {
                    if (res.success) {
                        let item = res.result
                        this.shopInfo = item
                        let addressTrance = areaData.getAreaNames([item.address.province, item.address.city, item.address.area]).join(" ")
                        this.shopInfo.addressDetail = `${addressTrance} ${item.address.detail}`
                        this.markerArr[0].title = item.name
                        this.markerArr[0].point = item.location.lng + "|" + item.location.lat
                        this.markerArr[0].content = `电话：${item.tel}<br />地址：${item.address.detail}`
                        //this.initMap();
                    } else {
                        this.$alert(res.error.message, '')
                    }
                }).catch(res => {

                })
            },
            //创建和初始化地图函数：
            initMap () {
                this.createMap()//创建地图
                this.setMapEvent()//设置地图事件
                this.addMapControl()//向地图添加控件
                this.addMarker()//向地图中添加marker
            },
            //创建地图函数：
            createMap () {
                var map = new BMap.Map('dituContent')//在百度地图容器中创建一个地图
                var point = new BMap.Point(this.shopInfo.location.lng, this.shopInfo.location.lat)//定义一个中心点坐标
                map.centerAndZoom(point, 16)//设定地图的中心点和坐标并将地图显示在地图容器中
                window.map = map//将map变量存储在全局
            },

            //地图事件设置函数：
            setMapEvent () {
                map.enableDragging()//启用地图拖拽事件，默认启用(可不写)
                map.enableScrollWheelZoom()//启用地图滚轮放大缩小
                map.enableDoubleClickZoom()//启用鼠标双击放大，默认启用(可不写)
                map.enableKeyboard()//启用键盘上下左右键移动地图
            },
            //地图控件添加函数：
            addMapControl () {
                //向地图中添加缩放控件
                var ctrl_nav = new BMap.NavigationControl({
                    anchor: BMAP_ANCHOR_TOP_LEFT,
                    type: BMAP_NAVIGATION_CONTROL_LARGE
                })
                map.addControl(ctrl_nav)
                //向地图中添加缩略图控件
                var ctrl_ove = new BMap.OverviewMapControl({ anchor: BMAP_ANCHOR_BOTTOM_RIGHT, isOpen: 1 })
                map.addControl(ctrl_ove)
                //向地图中添加比例尺控件
                var ctrl_sca = new BMap.ScaleControl({ anchor: BMAP_ANCHOR_BOTTOM_LEFT })
                map.addControl(ctrl_sca)
            },
            //创建marker
            addMarker () {
                for (var i = 0; i < that.markerArr.length; i++) {
                    var json = that.markerArr[i]
                    var p0 = json.point.split('|')[0]
                    var p1 = json.point.split('|')[1]
                    var point = new BMap.Point(p0, p1)
                    var iconImg = this.createIcon(json.icon)
                    var marker = new BMap.Marker(point, { icon: iconImg })
                    var iw = that.createInfoWindow(i)
                    var label = new BMap.Label(json.title, { 'offset': new BMap.Size(json.icon.lb - json.icon.x + 10, -20) })
                    marker.setLabel(label)
                    map.addOverlay(marker)
                    label.setStyle({
                        borderColor: '#808080',
                        color: '#333',
                        cursor: 'pointer'
                    });
                    (function () {
                        var index = i
                        var _iw = that.createInfoWindow(i)
                        var _marker = marker
                        _marker.addEventListener('click', function () {
                            _marker.openInfoWindow(_iw)
                        })
                        _iw.addEventListener('open', function () {
                            _marker.getLabel().hide()
                        })
                        _iw.addEventListener('close', function () {
                            _marker.getLabel().show()
                        })
                        label.addEventListener('click', function () {
                            _marker.openInfoWindow(_iw)
                        })
                        if (!!json.isOpen) {
                            label.hide()
                            _marker.openInfoWindow(_iw)
                        }
                    })()
                }
            },
            //创建InfoWindow
            createInfoWindow (i) {
                var json = that.markerArr[i]
                var iw = new BMap.InfoWindow('<b class=\'iw_poi_title\' title=\'' + json.title + '\'>' + json.title + '</b><div class=\'iw_poi_content\'>' + json.content + '</div>')
                return iw
            },
            //创建一个Icon
            createIcon (json) {
                var icon = new BMap.Icon('/mark.png', new BMap.Size(json.w, json.h), {
                    imageOffset: new BMap.Size(-json.l, -json.t),
                    infoWindowOffset: new BMap.Size(json.lb + 5, 1),
                    offset: new BMap.Size(json.x, json.h)
                })
                return icon
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner img {
        width: 100%;
        max-width: 1920px;
    }

    .shop-main {
        background: white;

        .content {
            margin: 20px auto 0;
            display: flex;
            flex-direction: row;
            padding-bottom: 50px;

            >div {
                margin: 0 auto;
                width: 50%;
                min-height: 250px;

                .text{
                    float: right;
                    width: 600px;
                    padding-top: 120px;
                    color: white;
                    text-align: left;
                    h3{
                        margin: 0;
                        padding: 0 0 20px 0;
                        font-size: 20px;
                    }
                    div{
                        line-height: 32px;
                    }
                }
            }

            div:first-child {
                background: #90ca6f;
            }
        }

    }

    .iw_poi_title {
        color: #CC5522;
        font-size: 14px;
        font-weight: bold;
        overflow: hidden;
        padding-right: 13px;
        white-space: nowrap
    }

    .iw_poi_content {
        font: 12px arial, sans-serif;
        overflow: visible;
        padding-top: 4px;
        white-space: -moz-pre-wrap;
        word-wrap: break-word
    }
</style>
